import { Text, TokenTextAppearance, TextTag } from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import { getLang, getTranslations } from '../../translations';
import { VehicleData } from '../../types';
import { VehicleCategory } from '../../types/enums/vehicles';
import { formatCurrency } from '../../utils/format';
import { getEVIncentives } from '../../utils/get-ev-incentives';
import { ResultsView, ResultsViewContext } from '../../utils/results-view-context';
import { VehicleContext } from '../../utils/vehicle-context';
import { DisclaimerMarker } from '../DisclaimerMarker';

export const Price = () => {
  const vehicle = useContext(VehicleContext) as VehicleData;
  const lang = getLang();

  const price = vehicle.category === VehicleCategory.NEW && vehicle.pcs
    ? Number(vehicle.pcs[lang].price.value)
    : Number(vehicle.price);

  const view = useContext(ResultsViewContext).value;
  const incentives = getEVIncentives(vehicle);

  const { disclaimers } = getTranslations();

  const getTextAppearance = () => {
    if (view === ResultsView.LIST) {
      return TokenTextAppearance.headline300;
    }
    return TokenTextAppearance.headline200;
  };

  // const priceNum = parseFloat(price.replace(/[^0-9.]/g,""));

  return (
    <Text
      tag={TextTag.p}
      appearance={getTextAppearance()}
      bold
    >
      { formatCurrency(price, true, lang) }{ incentives.count ? <DisclaimerMarker marker="◊◊" text={disclaimers.electric_pricing} id={`${vehicle.vin}-price`} variant="large"/> : null }
    </Text>
  );
};
